import { render, staticRenderFns } from "./haixue.vue?vue&type=template&id=2b27d3dd&scoped=true"
import script from "./haixue.vue?vue&type=script&lang=js"
export * from "./haixue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27d3dd",
  null
  
)

export default component.exports